import React from 'react';
import styles from './BillingTrendsChartSkeleton.module.css';

const BillingTrendsChartSkeleton: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}></div>
        <div className={styles.actions}>
          <div className={styles.viewToggle}>
            <div className={styles.viewOption}></div>
            <div className={styles.viewOption}></div>
          </div>
          <button className={styles.filterButton}>
            <div className={styles.filterIcon}></div>
          </button>
        </div>
      </div>
      
      <div className={styles.chartArea}>
        <div className={styles.yAxis}>
          {[...Array(5)].map((_, i) => (
            <div key={`y-${i}`} className={styles.yAxisLabel}></div>
          ))}
        </div>
        
        <div className={styles.chart}>
          <div className={styles.gridLines}>
            {[...Array(4)].map((_, i) => (
              <div key={`grid-${i}`} className={styles.gridLine}></div>
            ))}
          </div>
          
          <div className={styles.lines}>
            <div className={`${styles.line} ${styles.line1}`}></div>
            <div className={`${styles.line} ${styles.line2}`}></div>
            <div className={`${styles.line} ${styles.line3}`}></div>
          </div>
        </div>
      </div>
      
      <div className={styles.xAxis}>
        {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'].map((month, i) => (
          <div key={`x-${i}`} className={styles.xAxisLabel}></div>
        ))}
      </div>
      
      <div className={styles.legend}>
        <div className={styles.legendItem}>
          <div className={styles.legendColor}></div>
          <div className={styles.legendText}></div>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendColor}></div>
          <div className={styles.legendText}></div>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendColor}></div>
          <div className={styles.legendText}></div>
        </div>
      </div>
    </div>
  );
};

export default BillingTrendsChartSkeleton;
